<template>
  <div v-if="contentLoaded" class="campaign-detail">
    <div class="campaign-detail-part-1">
      <div class="campaign-event-icon">
        <SocialEvent3DIcon :event="campaign.socialEvent" />
      </div>
      <div class="campaign-name">
        {{ campaign.name }}
      </div>
    </div>
    <div class="campaign-detail-part-2">
      <CampaignBalance v-if="campaign.expired" :expired="true" />
      <CampaignBalance v-else :balance="campaign.amount" :total-balance="campaign.totalAmount" :expired="false"/>
    </div>
    <div class="campaign-detail-part-3">
      <div class="campaign-validity">
        <div class="campaign-validity-icon">
          <img src="@/assets/img/ico/calendar-check.svg" />
        </div>
        <div class="campaign-validity-date">
          {{ $t("campaign.validityFrom") }} {{ campaign.startDate }}<br> {{ $t("campaign.validityTo") }} <span class="campaign-validity-end-date">{{ campaign.endDate }}</span>
        </div>
      </div>
      <div class="campaign-social-event">
        <div class="campaign-social-event-title">
          {{ $t("campaign.categoryURSSAF") }} :
        </div>
        <div class="campaign-social-event-name">
          <div class="campaign-validity-icon">
            <SocialEvent2DIcon :event="campaign.socialEvent" />
          </div>
          <span>{{ campaign.socialEvent.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {ceApiService} from "@/_services/ceApiService";
  import SocialEvent3DIcon from "@/components/Campaign/SocialEvent3DIcon.vue";
  import SocialEvent2DIcon from "@/components/Campaign/SocialEvent2DIcon.vue";
  import CampaignBalance from "@/components/Campaign/CampaignBalance.vue";
  import {onMounted, ref} from "vue";

  const props = defineProps({
    'campaignUuid': {
      type: String,
      default: null
    },
  });

  let campaign = ref();
  let contentLoaded = ref(false);

  onMounted(async () => {
    const response = await ceApiService.getCampaign(props.campaignUuid);
    campaign.value = response.data;
    contentLoaded.value = true;
  });
</script>

<style scoped lang="scss">
  .campaign-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    align-self: stretch;
    min-width: 300px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;

    .campaign-detail-part-1 {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;

      @media only screen and (min-width: 630px) {
        max-width: 80%;
      }

      /*Mobile screen*/
      @media only screen and (max-width: 630px) {
        max-width: 95%;
      }

      .campaign-event-icon {
        width: 40.68px;
        height: 40.68px;
      }

      .campaign-name {
        color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
        font-size: 24px;
        font-weight: 700;
      }
    }

    .campaign-detail-part-2 {
      text-align: center;
      width: 100%;
    }

    .campaign-detail-part-3 {
      display: flex;
      padding: 0px 24px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;

      .campaign-validity {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
        gap: 10px;

        .campaign-validity-icon {
          width: 16px;
          height: 16px;
        }

        .campaign-validity-date {
          color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
          font-size: 12px;
          font-weight: 400;
          text-align: left;

          .campaign-validity-end-date {
            color: var(--ce-color-dark-blue-ce-marque-blanche-500, #0B1C48);
            font-size: 12px;
            font-weight: 700;
          }
        }
      }

      .campaign-social-event {
        text-align: right;

        .campaign-social-event-name {
          display: flex;
          flex-direction: row-reverse;
          gap: 5px;
        }
      }
    }
  }
</style>
